module.exports = __webpack_public_path__ + "static/media/Sauti_Studio_Design.2674d651.png";